import { readRuntimeConfigValue } from "@/shared/config/runtimeConfig";

export function parseFeatureFlag(value: unknown): boolean {
  if (typeof value === "boolean") return value;
  if (typeof value !== "string") return false;
  return value.trim().toLowerCase() === "true";
}

export function isDebugPanelEnabled(): boolean {
  return parseFeatureFlag(readRuntimeConfigValue("DEBUG_PANEL_ENABLED"));
}

export function isDebugRunObservationEnabled(): boolean {
  return parseFeatureFlag(readRuntimeConfigValue("DEBUG_RUN_OBSERVATION_ENABLED"));
}

export function isDeltaLogsEnabled(): boolean {
  return parseFeatureFlag(readRuntimeConfigValue("DELTA_LOGS_ENABLED"));
}

export function isSettingsMenuEnabled(): boolean {
  return parseFeatureFlag(readRuntimeConfigValue("SETTINGS_MENU_ENABLED"));
}

export function isQuickActionsEnabled(): boolean {
  return parseFeatureFlag(readRuntimeConfigValue("QUICK_ACTIONS_ENABLED"));
}

export function isVoiceEnabled(): boolean {
  return parseFeatureFlag(readRuntimeConfigValue("VOICE_ENABLED"));
}

export function isMemoryEnabled(): boolean {
  return parseFeatureFlag(readRuntimeConfigValue("MEMORY_ENABLED"));
}
